export default "__VITE_ASSET__fJbQx7WL__"